/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Public {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description Fetch a document in review or signing mode using a share token. No authentication required.
   *
   * @tags Public
   * @name GetPublicDocument
   * @summary Get Public Document
   * @request GET:/api/public/homysign
   */
  getPublicDocument = (query, params = {}) =>
    this.http.request({
      path: `/api/public/homysign`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Fetch public document by token path parameter.
   *
   * @tags Public
   * @name GetPublicDocumentByPath
   * @summary Get Public Document By Path
   * @request GET:/api/public/homysign/sign/{token}
   */
  getPublicDocumentByPath = (token, params = {}) =>
    this.http.request({
      path: `/api/public/homysign/sign/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Verify cryptographic integrity of a document using a public share token.
   *
   * @tags Public
   * @name VerifyPublicDocument
   * @summary Verify Public Document
   * @request GET:/api/public/homysign/verify
   */
  verifyPublicDocument = (query, params = {}) =>
    this.http.request({
      path: `/api/public/homysign/verify`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Record access audit trail event for an unauthenticated signer.
   *
   * @tags Public
   * @name RecordPublicAccessLog
   * @summary Record Public Access Log
   * @request POST:/api/public/homysign/access-log
   */
  recordPublicAccessLog = (query, data, params = {}) =>
    this.http.request({
      path: `/api/public/homysign/access-log`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Add an inline comment as an external reviewer (no login required).
   *
   * @tags Public
   * @name AddExternalComment
   * @summary Add External Comment
   * @request POST:/api/public/homysign/comments
   */
  addExternalComment = (query, data, params = {}) =>
    this.http.request({
      path: `/api/public/homysign/comments`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Decline to sign a document.
   *
   * @tags Public
   * @name DeclineSigning
   * @summary Decline Signing
   * @request POST:/api/public/homysign/decline
   */
  declineSigning = (query, params = {}) =>
    this.http.request({
      path: `/api/public/homysign/decline`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a signature as an external signer (no login required).
   *
   * @tags Public
   * @name SubmitPublicSignature
   * @summary Submit Public Signature
   * @request POST:/api/public/homysign/sign
   */
  submitPublicSignature = (query, data, params = {}) =>
    this.http.request({
      path: `/api/public/homysign/sign`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  verifyHomysign = (token, params = {}) => {
    const query = typeof token === "object" ? token : { token };
    return this.http.request({
      path: `/api/public/homysign/verify`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  };
  recordHomysignAccessLog = (token, data, params = {}) => {
    const query = typeof token === "object" ? token : { token };
    return this.http.request({
      path: `/api/public/homysign/access-log`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  };
  /**
   * @description Get a property by public slug (no authentication required). The property is public **iff** it carries at least one offer under the shared visibility rules — a PUBLISHED/ACTIVE listing on an AVAILABLE property that is not an onboarding draft (``wizardStep`` set). That is the same invariant Explore and the public asset redirect apply, so a property mid-wizard is invisible everywhere. The response is the allowlisted ``PublicPropertyResponse``: the management ``PropertyResponse`` is never served publicly.
   *
   * @tags Public
   * @name GetPublicProperty
   * @summary Get Public Property
   * @request GET:/api/public/listings/properties/{slug}
   */
  getPublicProperty = (slug, params = {}) =>
    this.http.request({
      path: `/api/public/listings/properties/${slug}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Render the public property page for a property that is **not public yet**. The token (purpose ``property-preview``, minted by ``POST /api/properties/{id}/property-preview-token``) is signed with the org id and property id, so it is both the authorization and the scope: the property is looked up by slug **within the token's organization**, and its id must equal the token's. Everything else is refused with the same ``ResourceNotFoundException`` the public route raises — an expired, malformed, wrong-purpose, wrong-property or cross-org token is indistinguishable from a slug that does not exist. The payload is the same allowlisted ``PublicPropertyResponse`` (never the management DTO), with two preview-only differences: DRAFT/PAUSED offers are included so an unpublished price renders, and each photo's durable URL is replaced by a short-lived presigned download URL for that photo's own asset — because the anonymous asset route correctly refuses a draft's photos and must stay that way.
   *
   * @tags Public
   * @name PreviewPublicProperty
   * @summary Preview a property's public page with a signed preview token
   * @request GET:/api/public/listings/properties/{slug}/preview
   */
  previewPublicProperty = (slug, query, params = {}) =>
    this.http.request({
      path: `/api/public/listings/properties/${slug}/preview`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Public search for listings.
   *
   * @tags Public
   * @name SearchListings
   * @summary Search Listings
   * @request GET:/api/public/listings/search
   */
  searchListings = (query, params = {}) =>
    this.http.request({
      path: `/api/public/listings/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Public listing details.
   *
   * @tags Public
   * @name GetListing
   * @summary Get Listing
   * @request GET:/api/public/listings/{listing_id}
   */
  getListing = (listingId, params = {}) =>
    this.http.request({
      path: `/api/public/listings/${listingId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Public listings for an organization slug.
   *
   * @tags Public
   * @name GetOrgListings
   * @summary Get Org Listings
   * @request GET:/api/public/listings/org/{slug}
   */
  getOrgListings = (slug, query, params = {}) =>
    this.http.request({
      path: `/api/public/listings/org/${slug}`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Submit a contact request for a listing.
   *
   * @tags Public
   * @name ContactListing
   * @summary Contact Listing
   * @request POST:/api/public/listings/{listing_id}/contact
   */
  contactListing = (listingId, data, params = {}) =>
    this.http.request({
      path: `/api/public/listings/${listingId}/contact`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Record a listing view for analytics.
   *
   * @tags Public
   * @name RecordListingView
   * @summary Record Listing View
   * @request POST:/api/public/listings/{listing_id}/view
   */
  recordListingView = (listingId, query, params = {}) =>
    this.http.request({
      path: `/api/public/listings/${listingId}/view`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Submit an application for a property
   *
   * @tags Public
   * @name SubmitApplication
   * @summary Submit Application
   * @request POST:/api/public/listings/properties/{slug}/apply
   */
  submitApplication = (slug, data, params = {}) =>
    this.http.request({
      path: `/api/public/listings/properties/${slug}/apply`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get read-only details of the sub-application / guarantor invitation for intake.
   *
   * @tags Public
   * @name GetPublicGuarantorIntake
   * @summary Get Public Guarantor Intake
   * @request GET:/api/public/applications/guarantor/{token}
   */
  getPublicGuarantorIntake = (token, params = {}) =>
    this.http.request({
      path: `/api/public/applications/guarantor/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Guarantor submits their sub-application, documents, and identity information.
   *
   * @tags Public
   * @name SubmitPublicGuarantorSubApplication
   * @summary Submit Guarantor Sub-Application
   * @request POST:/api/public/applications/guarantor/{token}/submit
   */
  submitPublicGuarantorSubApplication = (token, data, params = {}) =>
    this.http.request({
      path: `/api/public/applications/guarantor/${token}/submit`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get a read-only, sanitized view of an application via its public share token.
   *
   * @tags Public
   * @name GetPublicApplication
   * @summary Get Public Application
   * @request GET:/api/public/applications/{token}
   */
  getPublicApplication = (token, params = {}) =>
    this.http.request({
      path: `/api/public/applications/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Applicant voluntarily withdraws their application.
   *
   * @tags Public
   * @name WithdrawPublicApplication
   * @summary Withdraw Public Application
   * @request POST:/api/public/applications/{token}/withdraw
   */
  withdrawPublicApplication = (token, params = {}) =>
    this.http.request({
      path: `/api/public/applications/${token}/withdraw`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Get all information requests for this application using the public token.
   *
   * @tags Public
   * @name ListPublicInformationRequests
   * @summary List Public Information Requests
   * @request GET:/api/public/applications/{token}/information-requests
   */
  listPublicInformationRequests = (token, params = {}) =>
    this.http.request({
      path: `/api/public/applications/${token}/information-requests`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Submit a response to an information request.
   *
   * @tags Public
   * @name SubmitPublicInformationRequest
   * @summary Submit Public Information Request
   * @request POST:/api/public/applications/{token}/information-requests/{request_id}/submit
   */
  submitPublicInformationRequest = (token, requestId, data, params = {}) =>
    this.http.request({
      path: `/api/public/applications/${token}/information-requests/${requestId}/submit`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Public case intake from Help Center contact form or Chat Widget. If organization_id is provided, routes to Track 1 (ORGANIZATION). If organization_id is omitted, quarantines to Track 2 (PLATFORM). Returns unguessable 128-bit tracking_token for secure lookup.
   *
   * @tags Public
   * @name CreatePublicCase
   * @summary Public support case intake (dual-track quarantined)
   * @request POST:/api/public/support/cases
   */
  createPublicCase = (data, params = {}) =>
    this.http.request({
      path: `/api/public/support/cases`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Backward-compatibility alias for legacy public ticket submissions.
   *
   * @tags Public
   * @name CreatePublicTicketAlias
   * @summary Legacy public ticket submission alias
   * @request POST:/api/public/support/tickets
   */
  createPublicTicketAlias = (data, params = {}) =>
    this.http.request({
      path: `/api/public/support/tickets`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Secure public case status tracking using an unguessable 128-bit UUID token. Sequential case number lookup is strictly rejected to prevent IDOR and enumeration.
   *
   * @tags Public
   * @name TrackPublicCase
   * @summary Secure public case status and message tracking by UUID token
   * @request GET:/api/public/support/cases/track/{tracking_token}
   */
  trackPublicCase = (trackingToken, params = {}) =>
    this.http.request({
      path: `/api/public/support/cases/track/${trackingToken}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Post a guest reply to an existing public support case using its tracking token.
   *
   * @tags Public
   * @name AddPublicCaseMessage
   * @summary Guest reply to public case via tracking token
   * @request POST:/api/public/support/cases/track/{tracking_token}/messages
   */
  addPublicCaseMessage = (trackingToken, data, params = {}) =>
    this.http.request({
      path: `/api/public/support/cases/track/${trackingToken}/messages`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Public case status inquiry by unguessable tracking token. Sequential case numbers and entity IDs are strictly rejected to prevent IDOR and enumeration.
   *
   * @tags Public
   * @name GetPublicCase
   * @summary Get Public Case
   * @request GET:/api/public/support/cases/{reference_number}
   */
  getPublicCase = (referenceNumber, params = {}) =>
    this.http.request({
      path: `/api/public/support/cases/${referenceNumber}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Twilio SMS webhook: appends message to existing case or creates new case.
   *
   * @tags Public
   * @name TwilioSmsWebhook
   * @summary Twilio Sms Webhook
   * @request POST:/api/public/support/webhooks/twilio/sms
   */
  twilioSmsWebhook = (params = {}) =>
    this.http.request({
      path: `/api/public/support/webhooks/twilio/sms`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Twilio WhatsApp webhook: appends message to existing case or creates new case.
   *
   * @tags Public
   * @name TwilioWhatsappWebhook
   * @summary Twilio Whatsapp Webhook
   * @request POST:/api/public/support/webhooks/twilio/whatsapp
   */
  twilioWhatsappWebhook = (params = {}) =>
    this.http.request({
      path: `/api/public/support/webhooks/twilio/whatsapp`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Twilio Voice webhook returning TwiML instructions for caller recording.
   *
   * @tags Public
   * @name TwilioVoiceWebhook
   * @summary Twilio Voice Webhook
   * @request POST:/api/public/support/webhooks/twilio/voice
   */
  twilioVoiceWebhook = (params = {}) =>
    this.http.request({
      path: `/api/public/support/webhooks/twilio/voice`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Twilio Voice Recording callback: transcribes audio and creates case.
   *
   * @tags Public
   * @name TwilioVoiceRecordingWebhook
   * @summary Twilio Voice Recording Webhook
   * @request POST:/api/public/support/webhooks/twilio/voice/recording
   */
  twilioVoiceRecordingWebhook = (params = {}) =>
    this.http.request({
      path: `/api/public/support/webhooks/twilio/voice/recording`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Incoming Email webhook (SendGrid / AWS SES).
   *
   * @tags Public
   * @name EmailWebhook
   * @summary Email Webhook
   * @request POST:/api/public/support/webhooks/email
   */
  emailWebhook = (params = {}) =>
    this.http.request({
      path: `/api/public/support/webhooks/email`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Keyword and topic search across pre-seeded knowledge base articles.
   *
   * @tags Public
   * @name SearchHelpCenter
   * @summary Search Help Center Articles
   * @request POST:/api/public/support/help-center/search
   */
  searchHelpCenter = (data, params = {}) =>
    this.http.request({
      path: `/api/public/support/help-center/search`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all Help Center articles, optionally filtered by category or tag.
   *
   * @tags Public
   * @name ListHelpArticles
   * @summary List Help Center Articles
   * @request GET:/api/public/support/help-center/articles
   */
  listHelpArticles = (query, params = {}) =>
    this.http.request({
      path: `/api/public/support/help-center/articles`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve full article details and compiled markdown content by article slug.
   *
   * @tags Public
   * @name GetHelpArticle
   * @summary Get Help Center Article by Slug or ID
   * @request GET:/api/public/support/help-center/articles/{slug}
   */
  getHelpArticle = (slug, params = {}) =>
    this.http.request({
      path: `/api/public/support/help-center/articles/${slug}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve list of all supported Help Center categories.
   *
   * @tags Public
   * @name ListHelpCategories
   * @summary List Help Center Categories
   * @request GET:/api/public/support/help-center/categories
   */
  listHelpCategories = (params = {}) =>
    this.http.request({
      path: `/api/public/support/help-center/categories`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Explicit public unauthenticated streaming endpoint for guest chat.
   *
   * @tags Public
   * @name PublicChat
   * @summary Public Support Agent Chat Stream (Explicit)
   * @request POST:/api/public/agents/chat
   */
  publicChat = (data, params = {}) =>
    this.http.request({
      path: `/api/public/agents/chat`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Explicit public unauthenticated streaming endpoint for guest chat.
   *
   * @tags Public
   * @name PublicChat2
   * @summary Public Support Agent Chat Stream (Explicit)
   * @request POST:/api/public/support/chat
   * @originalName publicChat
   * @duplicate
   */
  publicChat2 = (data, params = {}) =>
    this.http.request({
      path: `/api/public/support/chat`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Resolve how to book a visit for a property. Public — no auth required. Returns the property's active event-type slug so the booking UI doesn't hardcode one. 404 if the property has no active visit configuration.
   *
   * @tags Public
   * @name GetPropertyBookingConfig
   * @summary Get Property Booking Config
   * @request GET:/api/public/calendar/properties/{slug}/booking-config
   */
  getPropertyBookingConfig = (slug, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/properties/${slug}/booking-config`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Resolve how to book a standalone event type (org-level, not property- scoped). Public — no auth required. 404 if unknown or inactive.
   *
   * @tags Public
   * @name GetEventBookingConfig
   * @summary Get Event Booking Config
   * @request GET:/api/public/calendar/org/{org_slug}/events/{event_slug}/booking-config
   */
  getEventBookingConfig = (orgSlug, eventSlug, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/org/${orgSlug}/events/${eventSlug}/booking-config`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get available booking slots for an event type. Public — no auth required.
   *
   * @tags Public
   * @name GetAvailableSlots
   * @summary Get Available Slots
   * @request GET:/api/public/calendar/slots
   */
  getAvailableSlots = (query, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/slots`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Create a booking. Public — no auth required.
   *
   * @tags Public
   * @name CreateBooking
   * @summary Create Booking
   * @request POST:/api/public/calendar/bookings
   */
  createBooking = (data, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/bookings`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Check booking status by UID. Public — returns limited info, no PII.
   *
   * @tags Public
   * @name GetBookingStatus
   * @summary Get Booking Status
   * @request GET:/api/public/calendar/bookings/{uid}
   */
  getBookingStatus = (uid, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/bookings/${uid}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Opt a booking in to a self-guided tour. Public — the booking uid is the credential. Idempotent: a repeat call returns the tour already arranged.
   *
   * @tags Public
   * @name RequestSelfGuidedTour
   * @summary Request Self Guided Tour
   * @request POST:/api/public/calendar/bookings/{uid}/self-guided-tour
   */
  requestSelfGuidedTour = (uid, data, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/bookings/${uid}/self-guided-tour`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description A visitor's tour pass. Public — the tour id is the credential.
   *
   * @tags Public
   * @name GetTourPass
   * @summary Get Tour Pass
   * @request GET:/api/public/calendar/tours/{tour_id}
   */
  getTourPass = (tourId, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/tours/${tourId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description The lock code: only once staff verified the visitor, the visit is confirmed and its time window is open. 403 otherwise.
   *
   * @tags Public
   * @name GetTourAccessCode
   * @summary Get Tour Access Code
   * @request GET:/api/public/calendar/tours/{tour_id}/access-code
   */
  getTourAccessCode = (tourId, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/tours/${tourId}/access-code`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description The visitor acknowledges arrival with their code. Repeating it is a no-op.
   *
   * @tags Public
   * @name CheckInTour
   * @summary Check In Tour
   * @request POST:/api/public/calendar/tours/{tour_id}/check-in
   */
  checkInTour = (tourId, data, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/tours/${tourId}/check-in`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description The visitor records departure, completing the tour and re-arming the smart lock.
   *
   * @tags Public
   * @name CheckoutTour
   * @summary Checkout Tour
   * @request POST:/api/public/calendar/tours/{tour_id}/checkout
   */
  checkoutTour = (tourId, params = {}) =>
    this.http.request({
      path: `/api/public/calendar/tours/${tourId}/checkout`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description Allow an unauthenticated external marketplace contractor to inspect work order details.
   *
   * @tags Public
   * @name GetPublicDispatch
   * @summary Public Guest Vendor Dispatch Inspection
   * @request GET:/api/public/maintenance/dispatch/{token}
   */
  getPublicDispatch = (token, params = {}) =>
    this.http.request({
      path: `/api/public/maintenance/dispatch/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description External contractor accepts dispatch, transitioning work order to ASSIGNED.
   *
   * @tags Public
   * @name AcceptPublicDispatch
   * @summary Public Guest Vendor Accept Dispatch
   * @request POST:/api/public/maintenance/dispatch/{token}/accept
   */
  acceptPublicDispatch = (token, params = {}) =>
    this.http.request({
      path: `/api/public/maintenance/dispatch/${token}/accept`,
      method: "POST",
      format: "json",
      ...params,
    });
  /**
   * @description External contractor declines dispatch.
   *
   * @tags Public
   * @name DeclinePublicDispatch
   * @summary Public Guest Vendor Decline Dispatch
   * @request POST:/api/public/maintenance/dispatch/{token}/decline
   */
  declinePublicDispatch = (token, data, params = {}) =>
    this.http.request({
      path: `/api/public/maintenance/dispatch/${token}/decline`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description External contractor submits a cost quote directly from a guest dispatch link.
   *
   * @tags Public
   * @name SubmitPublicDispatchQuote
   * @summary Public Guest Vendor Quote Submission
   * @request POST:/api/public/maintenance/dispatch/{token}/quote
   */
  submitPublicDispatchQuote = (token, data, params = {}) =>
    this.http.request({
      path: `/api/public/maintenance/dispatch/${token}/quote`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Resolve Share.
   *
   * @tags Public
   * @name ResolveShare
   * @summary Resolve Share
   * @request GET:/api/public/share/{token}
   */
  resolveShare = (token, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get Shared Maintenance Project.
   *
   * @tags Public
   * @name GetSharedMaintenanceProject
   * @summary Get Shared Maintenance Project
   * @request GET:/api/public/share/{token}/maintenance-project
   */
  getSharedMaintenanceProject = (token, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/maintenance-project`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Patch Shared Maintenance Project.
   *
   * @tags Public
   * @name PatchSharedMaintenanceProject
   * @summary Patch Shared Maintenance Project
   * @request PATCH:/api/public/share/{token}/maintenance-project
   */
  patchSharedMaintenanceProject = (token, data, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/maintenance-project`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Shared Maintenance Request with enriched property, occurrences, checklist, and bank details.
   *
   * @tags Public
   * @name GetSharedMaintenanceRequest
   * @summary Get Shared Maintenance Request
   * @request GET:/api/public/share/{token}/maintenance-request
   */
  getSharedMaintenanceRequest = (token, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/maintenance-request`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Mark a maintenance occurrence completed via public share link.
   *
   * @tags Public
   * @name CompleteSharedOccurrence
   * @summary Complete Shared Occurrence
   * @request POST:/api/public/share/{token}/maintenance-request/occurrences/{occurrence_id}/complete
   */
  completeSharedOccurrence = (token, occurrenceId, data, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/maintenance-request/occurrences/${occurrenceId}/complete`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Submit worker bank payout details via public share link.
   *
   * @tags Public
   * @name SubmitSharedBankDetails
   * @summary Submit Shared Bank Details
   * @request PUT:/api/public/share/{token}/maintenance-request/bank-details
   */
  submitSharedBankDetails = (token, data, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/maintenance-request/bank-details`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Shared Maintenance Statement.
   *
   * @tags Public
   * @name GetSharedMaintenanceStatement
   * @summary Get Shared Maintenance Statement
   * @request GET:/api/public/share/{token}/maintenance-statement
   */
  getSharedMaintenanceStatement = (token, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/maintenance-statement`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get Shared Rental Contract.
   *
   * @tags Public
   * @name GetSharedRentalContract
   * @summary Get Shared Rental Contract
   * @request GET:/api/public/share/{token}/rental-contract
   */
  getSharedRentalContract = (token, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/rental-contract`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Patch Shared Line Item.
   *
   * @tags Public
   * @name PatchSharedLineItem
   * @summary Patch Shared Line Item
   * @request PATCH:/api/public/share/{token}/line-items/{line_item_id}
   */
  patchSharedLineItem = (token, lineItemId, data, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/line-items/${lineItemId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Share Notes.
   *
   * @tags Public
   * @name ListShareNotes
   * @summary List Share Notes
   * @request GET:/api/public/share/{token}/notes
   */
  listShareNotes = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/notes`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Create Share Note.
   *
   * @tags Public
   * @name CreateShareNote
   * @summary Create Share Note
   * @request POST:/api/public/share/{token}/notes
   */
  createShareNote = (token, data, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/notes`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get the caller's schedule for a shared event type.
   *
   * @tags Public
   * @name GetSharedAvailability
   * @summary Get Shared Availability
   * @request GET:/api/public/share/{token}/availability
   */
  getSharedAvailability = (token, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/availability`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Update availability windows for a shared event type.
   *
   * @tags Public
   * @name UpdateSharedAvailability
   * @summary Update Shared Availability
   * @request PUT:/api/public/share/{token}/availability
   */
  updateSharedAvailability = (token, data, params = {}) =>
    this.http.request({
      path: `/api/public/share/${token}/availability`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Generate or retrieve a 1200x630 Dark Spatial Bento PNG image preview for a shareable link.
   *
   * @tags Public
   * @name GetShareOgImage
   * @summary Get Share Og Image
   * @request GET:/api/public/og/share/{token}
   */
  getShareOgImage = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/og/share/${token}`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Generate or retrieve a 1200x630 Dark Spatial Bento PNG image preview for a shareable link.
   *
   * @tags Public
   * @name GetShareOgImage2
   * @summary Get Share Og Image
   * @request GET:/api/public/og/share/{token}.png
   * @originalName getShareOgImage
   * @duplicate
   */
  getShareOgImage2 = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/og/share/${token}.png`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Return Open Graph SSR HTML for social unfurling with instant human browser redirect.
   *
   * @tags Public
   * @name UnfurlShareLink
   * @summary Unfurl Share Link
   * @request GET:/api/public/unfurl/public/{token}
   */
  unfurlShareLink = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/unfurl/public/${token}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * @description Return Open Graph SSR HTML for social unfurling with instant human browser redirect.
   *
   * @tags Public
   * @name UnfurlShareLink2
   * @summary Unfurl Share Link
   * @request GET:/api/public/unfurl/public/forms/{token}
   * @originalName unfurlShareLink
   * @duplicate
   */
  unfurlShareLink2 = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/unfurl/public/forms/${token}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * @description Return Open Graph SSR HTML for social unfurling with instant human browser redirect.
   *
   * @tags Public
   * @name UnfurlShareLink3
   * @summary Unfurl Share Link
   * @request GET:/api/public/unfurl/public/applications/{token}
   * @originalName unfurlShareLink
   * @duplicate
   */
  unfurlShareLink3 = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/unfurl/public/applications/${token}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * @description Return Open Graph SSR HTML for social unfurling with instant human browser redirect.
   *
   * @tags Public
   * @name UnfurlShareLink4
   * @summary Unfurl Share Link
   * @request GET:/api/public/unfurl/homysign/sign/{token}
   * @originalName unfurlShareLink
   * @duplicate
   */
  unfurlShareLink4 = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/unfurl/homysign/sign/${token}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * @description Return Open Graph SSR HTML for social unfurling with instant human browser redirect.
   *
   * @tags Public
   * @name UnfurlShareLink5
   * @summary Unfurl Share Link
   * @request GET:/api/public/unfurl/sign/{token}
   * @originalName unfurlShareLink
   * @duplicate
   */
  unfurlShareLink5 = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/unfurl/sign/${token}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * @description Return Open Graph SSR HTML for social unfurling with instant human browser redirect.
   *
   * @tags Public
   * @name UnfurlShareLink6
   * @summary Unfurl Share Link
   * @request GET:/api/public/unfurl/share/{token}
   * @originalName unfurlShareLink
   * @duplicate
   */
  unfurlShareLink6 = (token, query, params = {}) =>
    this.http.request({
      path: `/api/public/unfurl/share/${token}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * @description Public endpoint — returns the published landing page configuration for the organization identified by slug. Returns 404 if no landing page exists or it is not published. When preview=true and the caller is an authenticated member of the organization, returns the landing page even if it is not yet published. Unauthorized preview requests degrade to normal public behavior instead of failing: published pages render for everyone (stale preview links keep working), and drafts stay hidden behind the same 404 as any public request — never revealing that a draft exists.
   *
   * @tags Public
   * @name GetPublicLandingPage
   * @summary Get published landing page for an organization
   * @request GET:/api/public/organizations/{slug}/landing-page
   * @secure
   */
  getPublicLandingPage = (slug, query, params = {}) =>
    this.http.request({
      path: `/api/public/organizations/${slug}/landing-page`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Inspect public invitation metadata before accepting or authenticating.
   *
   * @tags Public
   * @name PreviewInvitationPublic
   * @summary Public Preview Invitation
   * @request GET:/api/public/invitations/{token}
   */
  previewInvitationPublic = (token, params = {}) =>
    this.http.request({
      path: `/api/public/invitations/${token}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Get Public Form.
   *
   * @tags Public
   * @name GetPublicForm
   * @summary Get Public Form
   * @request GET:/api/public/forms
   */
  getPublicForm = (query, params = {}) =>
    this.http.request({
      path: `/api/public/forms`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Submit Public Form.
   *
   * @tags Public
   * @name SubmitPublicForm
   * @summary Submit Public Form
   * @request POST:/api/public/forms/submit
   */
  submitPublicForm = (query, data, params = {}) =>
    this.http.request({
      path: `/api/public/forms/submit`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Save Form Draft.
   *
   * @tags Public
   * @name SaveFormDraft
   * @summary Save Form Draft
   * @request POST:/api/public/forms/save-draft
   */
  saveFormDraft = (query, data, params = {}) =>
    this.http.request({
      path: `/api/public/forms/save-draft`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Request a presigned URL for public file upload associated with a shared form.
   *
   * @tags Public
   * @name RequestPublicUploadUrl
   * @summary Request Public Upload Url
   * @request POST:/api/public/forms/upload-url
   */
  requestPublicUploadUrl = (query, data, params = {}) =>
    this.http.request({
      path: `/api/public/forms/upload-url`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Confirm a public file upload.
   *
   * @tags Public
   * @name ConfirmPublicUpload
   * @summary Confirm Public Upload
   * @request POST:/api/public/forms/assets/{asset_id}/confirm
   */
  confirmPublicUpload = (assetId, query, data, params = {}) =>
    this.http.request({
      path: `/api/public/forms/assets/${assetId}/confirm`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Public
   * @name GetPublicAsset
   * @summary Redirect to a fresh download URL for a publicly referenced asset
   * @request GET:/api/public/assets/{asset_id}
   */
  getPublicAsset = (assetId, params = {}) =>
    this.http.request({
      path: `/api/public/assets/${assetId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * @description Paged marketplace cards for the current filter and viewport.
   *
   * @tags Public
   * @name SearchExplore
   * @summary Search public listings across all organizations
   * @request GET:/api/public/explore/search
   */
  searchExplore = (query, params = {}) =>
    this.http.request({
      path: `/api/public/explore/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Compact points for the map layer; same filters as search, bounds required.
   *
   * @tags Public
   * @name ExploreMarkers
   * @summary Map markers for the current viewport
   * @request GET:/api/public/explore/markers
   */
  exploreMarkers = (query, params = {}) =>
    this.http.request({
      path: `/api/public/explore/markers`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Fast prefix search against the place index, or browse a country's top places.
   *
   * @tags Public
   * @name ListExplorePlaces
   * @summary Explore place suggestions
   * @request GET:/api/public/explore/places
   */
  listExplorePlaces = (query, params = {}) =>
    this.http.request({
      path: `/api/public/explore/places`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Paged directory of organizations with a published landing page.
   *
   * @tags Public
   * @name ListExploreAgents
   * @summary Explore agents directory
   * @request GET:/api/public/explore/agents
   */
  listExploreAgents = (query, params = {}) =>
    this.http.request({
      path: `/api/public/explore/agents`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Aggregated market intelligence telemetry (median prices, 30-day listing volume, property types) for public Explore place pages.
   *
   * @tags Public
   * @name GetExploreInsights
   * @summary Explore Market Insights
   * @request GET:/api/public/explore/insights
   */
  getExploreInsights = (query, params = {}) =>
    this.http.request({
      path: `/api/public/explore/insights`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Up to four neighbour cards; fewer than two and the client hides the row.
   *
   * @tags Public
   * @name ExploreSimilar
   * @summary Similar homes near a property
   * @request GET:/api/public/explore/similar
   */
  exploreSimilar = (query, params = {}) =>
    this.http.request({
      path: `/api/public/explore/similar`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Public vendor directory for the marketplace explore section.
   *
   * @tags Public
   * @name SearchExploreVendors
   * @summary Explore vendors directory
   * @request GET:/api/public/explore/vendors
   */
  searchExploreVendors = (query, params = {}) =>
    this.http.request({
      path: `/api/public/explore/vendors`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * @description Public vendor service request endpoint. Frictionless lead-generation and maintenance request dispatch. Provisions shadow vendor user if unclaimed, resolves or creates requesting user and organization, creates property, registers saved vendor, and generates MaintenanceRequest record.
   *
   * @tags Public
   * @name SubmitVendorServiceRequest
   * @summary Submit public vendor service request
   * @request POST:/api/public/explore/vendors/{vendor_id}/service-request
   * @secure
   */
  submitVendorServiceRequest = (vendorId, data, params = {}) =>
    this.http.request({
      path: `/api/public/explore/vendors/${vendorId}/service-request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
